import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/CircleNotch.es.js";
const c = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: a }));
c.displayName = "CircleNotchIcon";
const s = c;
export {
  s as CircleNotch,
  c as CircleNotchIcon
};
